export default __webpack_public_path__ + "static/media/54.7e8cc8cd.jpeg";